import { render, staticRenderFns } from "./KSearch.vue?vue&type=template&id=4c4221b2&scoped=true&"
import script from "./KSearch.vue?vue&type=script&lang=js&"
export * from "./KSearch.vue?vue&type=script&lang=js&"
import style0 from "./KSearch.vue?vue&type=style&index=0&id=4c4221b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4221b2",
  null
  
)

export default component.exports